import { get, post } from './http-calls';
import moment from 'moment';

const downloadFileWithExt = async (res, fileExt, fileName = 'file') => {
    if (res) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.getElementById('tempDownloadPDFLink') || document.createElement('a');
        link.id = 'tempDownloadPDFLink';
        link.href = url;
        link.setAttribute('download', `${fileName}${moment().format('DD-MMM-YYYY HH:mm')}.${fileExt}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        return true;
    }
};

export const GetTCardDashDropdowns = async () => {
    let res = await get(`TCards/TCardDash_DropDowns`, {
        useAuthToken: true
    });
    return res;
};

export const getTCardSchedules = async (branchID, startDate, endDate) => {
    let res = await get(`TCardSchedules/TCards_GetSchedules?BranchID=${branchID || ''}&StartDate=${startDate}&EndDate=${endDate}`, {
        useAuthToken: true
    });
    return res;
};

export const GetTCards_GetCustomerNotifications = async (CustomerID) => {
    let res = await get(`TCardCustomers/TCards_GetCustomerNotifications?CustomerID=${CustomerID}`, {
        useAuthToken: true
    });
    return res;
};

export const GetTCards_GetCustomers = async () => {
    let res = await get(`TCardCustomers/TCards_GetCustomers`, {
        useAuthToken: true
    });
    return res;
};

export const postTCard_AddUpdateCustomerNotifications = async (CustomerID, data) => {
    let res = await post(`TCardCustomers/TCard_AddUpdateCustomerNotifications?CustomerID=${CustomerID}`, data, { useAuthToken: true });
    return res;
};

export const postTCardsUpdateStatus = async (TCardsStatusID, TCardsID) => {
    let res = await post(`TCards/TCardsUpdateStatus?TCardsID=${TCardsID}&TCardsStatusID=${TCardsStatusID}`, {}, { useAuthToken: true });
    return res;
};

export const GetTCards_GetItems = async (TCardsID) => {
    let res = await get(`TCards/TCards_GetItems?TCardsID=${TCardsID}`, {
        useAuthToken: true
    });
    return res;
};
export const getTCardSchedulesExcelFile = async (branchID, startDate, endDate) => {
    let res = await get(`TCardSchedules/TCards_GetSchedules?BranchID=${branchID || ''}&StartDate=${startDate}&EndDate=${endDate}&fileType=excel`, {
        responseType: 'blob',
        returnOrgRes: true,
        useAuthToken: true
    });
    downloadFileWithExt(res, 'xlsx', 'TCardSchedules');
};

export const getTCardCustomersGetExcelFile = async (CustID) => {
    let res = await get(`TCardCustomers/GetExcelFile?TCardCustomerID=${CustID}`, {
        responseType: 'blob',
        returnOrgRes: true,
        useAuthToken: true
    });
    downloadFileWithExt(res, 'xlsx', 'TCardCustomers');
};

export let uploadUploadCustomerDetails = async (TCardCustomerID, formData) => {
    let data = await post(`TCardCustomers/UploadCustomerDetails/${TCardCustomerID}`, formData, { useAuthToken: true });
    return data;
};

export let getTcardCustomerNotesScreenDropdown = async () => {
    let data = await get(`TCardCustomers/TCardCustomerNotes_ScreenDropdown`, { useAuthToken: true });
    return data;
};

export let getTcardCustomerNotesGetDetails = async (id) => {
    let data = await get(`TCardCustomers/TCardCustomersNotes_GetDetails?TCardCustomerID=${id}`, { useAuthToken: true });
    return data;
};

export const postTcardAddUpdateCustomerNotes = async (data) => {
    let res = await post(`TCardCustomers/TCardCustomerNotes_AddUpdate`, data, { useAuthToken: true });
    return res;
};

export let getTcardScheduleEventsScreenDropdown = async () => {
    let data = await get(`TCardScheduleEvents/TCardScheduleEvents_ScreenDropdown`, { useAuthToken: true });
    return data;
};

export const postTcardScheduleEventsAddUpdate = async (id, tCardWorkTypeEventID) => {
    let res = await post(`TCardScheduleEvents/TCardScheduleEvents_AddUpdate?Id=${id}&TCardWorkTypeID=${tCardWorkTypeEventID}`, {}, { useAuthToken: true });
    return res;
};

export let getGetTCradBookingsByBranch_Month_Year = async (BranchID, Month, Year, CustomerName) => {
    let data = await get(`TCards/GetTCradBookingsByBranch_Month_Year?BranchID=${BranchID}&Month=${Month}&Year=${Year}`, {
        useAuthToken: true
    });
    return data;
};
